export const SkeletonCard = () => (
  <>
    <div className="w-full space-y-6 p-4">
      <div className="mx-auto w-full rounded-xl border border-gray-200 p-3 shadow-sm">
        <div className="flex items-center space-x-5">
          <div className="size-16 animate-shimmer rounded-full bg-gray-300 bg-gradient-to-r from-gray-300 via-gray-200 to-gray-300 bg-[length:300%_100%]"></div>
          <div className="flex-1 space-y-3">
            <div className="h-5 animate-shimmer rounded bg-gray-300 bg-gradient-to-r from-gray-300 via-gray-200 to-gray-300 bg-[length:300%_100%]"></div>
            <div className="h-4 w-2/3 animate-shimmer rounded bg-gray-300 bg-gradient-to-r from-gray-300 via-gray-200 to-gray-300 bg-[length:300%_100%]"></div>
          </div>
        </div>

        <div className="mt-6 space-y-3">
          <div className="h-20 animate-shimmer rounded bg-gray-300 bg-gradient-to-r from-gray-300 via-gray-200 to-gray-300 bg-[length:300%_100%]"></div>
          <div className="h-4 w-5/6 animate-shimmer rounded bg-gray-300 bg-gradient-to-r from-gray-300 via-gray-200 to-gray-300 bg-[length:300%_100%]"></div>
          <div className="h-4 w-2/3 animate-shimmer rounded bg-gray-300 bg-gradient-to-r from-gray-300 via-gray-200 to-gray-300 bg-[length:300%_100%]"></div>
          <div className="h-4 w-2/3 animate-shimmer rounded bg-gray-300 bg-gradient-to-r from-gray-300 via-gray-200 to-gray-300 bg-[length:300%_100%]"></div>
        </div>
      </div>
    </div>
  </>
);
